var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('title-text'),_c('content-text'),_c('ordering-number')],1),_c('b-button',{attrs:{"variant":"primary","disabled":_vm.itemData.submitStatus},on:{"click":_vm.submitForm}},[_vm._v(" Kaydet ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }